import { Auth } from "aws-amplify";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { RiCloseLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { isEmailChar, validateEmail, invokeLambdaWithRetry } from "services/Helper";
import MeaBannerIcon from "../../newui/assets/images/login_mea_banner.svg";
import MeaIcon from "../../newui/assets/images/Mea-Logo 1.svg";
import "../assets/css/style.css";
import logo from "../assets/images/logo.png";
import "../assets/vendors/base/vendor.bundle.base.css";
import "../assets/vendors/ti-icons/css/themify-icons.css";
import CirclesLoader from "../layouts/CirclesLoader";
import { createUiLogger } from "../../logging/uiLogger";
const console = createUiLogger("meaplatform/classic/views/PasswordReset.js");



function PasswordReset() {
  const [showModal, setShowModal] = React.useState(false);
  const [showModalMsg, setShowModalMsg] = React.useState("");
  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");
  let [showPassword, setShowPassword] = useState(false);
  let [authenticationCode, setAuthenticationCode] = useState("");
  let [step, setStep] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  function convertToUserName(email) {
    return email;
  }

  const allowEmailChars = (e) => {
    if (isEmailChar(e.key) === false) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  let forgotPassword = async (event) => {
    event.preventDefault();
    var username = convertToUserName(email);
    if (username.trim().length === 0) return;
    if (validateEmail(email) !== true) return;
    try {
      const body = {
        target: "forgot-password",
        username: username,
      };
      const init = { body };
      await invokeLambdaWithRetry("instanceHandler", init);
      setStep(1);
    } catch (err) {
      setStep(1);
    }
  };

  let forgotPasswordSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    var username = convertToUserName(email);
    if (authenticationCode.trim().length === 0) return;
    try {
      await Auth.forgotPasswordSubmit(username, authenticationCode, password)
        .then(async (data) => {
          let path = `/login`;
          navigate(path);
        })
        .catch((err) => {
          setShowModalMsg(err.message);
          setShowModal(true);
          return;
        });
    } catch (err) {
      setShowModalMsg(err.message);
      setShowModal(true);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const redirectToLogin = () => {
    let path = `/login`;
    navigate(path);
  };

  const handleAuthCode = (event) => {
    if (event.target.checkValidity()) {
      setAuthenticationCode(event.target.value);
    }
  };

  return (
    <>
      <div className="authlayout-container p-3">
        <div className="h-100 authform-container flex">
          <div className="meaicon-banner p-2 flex-center">
            <div className="w-100">
              <img src={MeaBannerIcon} alt="MeaBannerIcon" className="w-100" />
            </div>
          </div>

          <div className="flex authlogo-formcontainer">
            <div className="w-55 flex-colcenter">
              <div>
                <div className="flex-center mb-3">
                  <div className="auth-mealogo-texticon">
                    <img src={logo} alt="MeaIconText" className="w-100" />
                  </div>
                </div>
                <div className="w-100">
                  <div className="flex-center">
                    <h1 className="authform-measlogan-text">make your life</h1>
                  </div>
                  <div className="flex-center">
                    <h1 className="authform-measlogan-text">easier</h1>
                  </div>
                </div>
              </div>
              <p className="authform-limitedyear">
                mea platform limited {new Date().getFullYear()}.
              </p>
            </div>
            <div className="authform-layoutcontainer flex-colcenter">
              <div className="authform-fieldcontainer">
                <div className="mb-4 mt-4 authform-mealogo-container">
                  <img
                    src={MeaIcon}
                    alt="MEA-ICON"
                    className="authform-mealogoicon"
                  />
                </div>
                <h1 className="formcontainer-title text-center">
                  Forgot Password
                </h1>
                <h5 className="text-center authform-subtitle  mt-1 mb-1">
                  Enter a valid e-mail address to continue
                </h5>
                {step === 1 && <h5 className="text-center mt-1 mb-1 sm-txt">
                  (Auth code would be sent to your registered email address)
                </h5>}
                <div className="auth-form-transparent text-left login-form">
                  {step === 0 && (
                    <form className="pt-3">
                      <div className="form-group formcontainer-input-textfield mb-5">
                        <label className="login-formlabel text-left">
                          Email address
                        </label>
                        <div className="input-group">
                          <input
                            type="email"
                            className="formcontainer-inputfield"
                            value={email}
                            onKeyDown={allowEmailChars}
                            onChange={(event) => {
                              setEmail(event.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="my-3 row mx-0 justify-content-center">
                        <button
                          type="Submit"
                          className="formfields-button mb-3 authenticate-btn"
                          disabled={!/^[^\s@]+@[^\s@]+$/.test(email)}
                          onClick={forgotPassword}
                        >
                          Submit
                        </button>
                        <button
                          type="Submit"
                          className="formfields-button authenticate-btn"
                          onClick={redirectToLogin}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  )}

                  {step === 1 && (
                    <form className="pt-3">
                      <div className="form-group mb-2 formcontainer-input-textfield">
                        <label className="login-formlabel text-left">
                          Email address
                        </label>
                        <div className="input-group">
                          <input
                            type="email"
                            className="formcontainer-inputfield"
                            placeholder="enter valid email id"
                            readOnly={true}
                            value={email}
                            onChange={(event) => {
                              setEmail(event.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="form-group mb-2 formcontainer-input-textfield">
                        <label className="login-formlabel text-left">
                          Authentication Code
                        </label>
                        <div className="input-group">
                          <input
                            id="authenticationCode"
                            name="authenticationCode"
                            type="text"
                            className="formcontainer-inputfield"
                            value={authenticationCode}
                            pattern="[0-9]*"
                            onChange={handleAuthCode}
                          />
                        </div>
                      </div>
                      <div className="form-group mb-5  formcontainer-input-textfield forgotpwd">
                        <label className="login-formlabel text-left">
                          Password
                        </label>
                        <div className="input-group">
                          <input
                            id="resetpassword"
                            name="resetpassword"
                            autoComplete="new-password"
                            type={showPassword ? "text" : "password"}
                            className="formcontainer-inputfield"
                            value={password}
                            onChange={(event) => {
                              setPassword(event.target.value);
                            }}
                          />
                          {password && (
                            <span className="show-pwd">
                              <button
                                className="btn p-0 auth-link text-black"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowPassword(!showPassword);
                                }}
                              >
                                {showPassword ? "hide" : "show"}
                              </button>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="my-3 row mx-0 justify-content-center">
                        <button
                          type="button"
                          className="formfields-button mb-3"
                          disabled={
                            authenticationCode.length < 6 ||
                            password.length === 0
                          }
                          onClick={forgotPasswordSubmit}
                        >
                          Change Password
                        </button>
                        <button
                          type="button"
                          className="formfields-button"
                          onClick={redirectToLogin}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
              <div className="flex-center">
                <p className="login-footertitle login-div-footer-title">
                  read mea
                  <a
                    className="login-form-footer-text font-Poppins mr-1 ml-1"
                    href="https://www.meaplatform.com/privacy-policy/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    privacy policies
                  </a>
                  and
                  <a
                    className="login-form-footer-text font-Poppins mr-1 ml-1"
                    href="https://www.meaplatform.com/terms/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    terms and conditions
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mini Modal */}
      <Modal
        className="modal-mini modal-primary new-modal"
        show={showModal}
        onHide={() => setShowModal(false)}
        animation={false}
        centered={true}
      >
        <Modal.Header className="justify-content-end pt-2">
          <button className="closeicon" onClick={() => setShowModal(false)}>
            <RiCloseLine />
          </button>
        </Modal.Header>
        <Modal.Body className="text-center modal-msg">
          <p>{showModalMsg}</p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center pb-0">
          <p>
            powered by <span>mea platform</span>
          </p>
        </Modal.Footer>
      </Modal>
      {/* End Modal */}
      {/* Mini Modal */}
      <Modal
        className="modal-centre new-modal"
        backdrop="static"
        keyboard={false}
        show={isLoading}
        animation={false}
        centered={true}
      >
        <Modal.Body className="text-center">
          <CirclesLoader isLoading={isLoading} />
        </Modal.Body>
      </Modal>
      {/* End Modal */}
    </>
  );
}

export default PasswordReset;
